export default "__VITE_ASSET__FMg_HDMR__"